import {
    MenuConfigurationItem,
    MenuItemType,
    RBHierarchyTemplateviewItem,
    RBTemplates,
} from 'store/railsBuilder/reducer.types';
import {
    MENU_ITEMS_ADDITIONAL_PARAMS,
    MODULAR_TEMPLATEVIEWS_NAMES,
} from 'store/railsBuilder/utils/constants';

function getPageTypeByName(name: RBTemplates) {
    if (name === RBTemplates.TV) {
        return MenuItemType.EPG;
    }

    if (MODULAR_TEMPLATEVIEWS_NAMES.includes(name)) {
        return MenuItemType.MODULAR;
    }

    if (name === RBTemplates.Search) {
        return MenuItemType.SEARCH;
    }

    if (name === RBTemplates.Settings || name === RBTemplates.SettingsKids) {
        return MenuItemType.SETTINGS;
    }

    return undefined;
}

function createMenuItems(
    templateviews: RBHierarchyTemplateviewItem[],
): MenuConfigurationItem[] {
    return templateviews.map<MenuConfigurationItem>((templateview) => {
        const menuItem = {
            id: templateview.id,
            name: templateview.name,
            type: getPageTypeByName(templateview.name),
            ...(MENU_ITEMS_ADDITIONAL_PARAMS[
                templateview.name as keyof typeof MENU_ITEMS_ADDITIONAL_PARAMS
            ] ?? {
                POEditorKey: templateview.name,
                icon: '',
            }),
        };

        if (templateview.children.length) {
            return {
                ...menuItem,
                children: createMenuItems(templateview.children),
            };
        }

        return menuItem;
    });
}

function createMenuConfiguration(
    hierarchy: RBHierarchyTemplateviewItem[],
): MenuConfigurationItem[] {
    return hierarchy.reduce<MenuConfigurationItem[]>((acc, mobileTemplate) => {
        switch (mobileTemplate.name) {
            case RBTemplates.Menu:
            case RBTemplates.MenuKids:
                return [...acc, ...createMenuItems(mobileTemplate.children)];
            case RBTemplates.Settings:
            case RBTemplates.SettingsKids:
            case RBTemplates.Search:
                return [...acc, ...createMenuItems([mobileTemplate])];
            default:
                return acc;
        }
    }, []);
}

export default createMenuConfiguration;
